import { Cloudinary } from 'cloudinary-core';

import getStringEnvVar from 'lib/getStringEnvVar';

export default new Cloudinary({
  cloud_name: getStringEnvVar('REACT_APP_CLOUDINARY_CLOUD_NAME'),
});
